import { isApiErrorOfCode } from 'utils'
import { CHANGE_PASSWORD_ERROR_CODES } from './consts'

export const isPasswordInvalidError = error =>
  isApiErrorOfCode(CHANGE_PASSWORD_ERROR_CODES.OLD_PASSWORD_INVALID)(error) ||
  isApiErrorOfCode(CHANGE_PASSWORD_ERROR_CODES.OLD_PASSWORD_NOT_VALID)(error)
